import React from 'react';
import * as PropTypes from 'prop-types';

const Loader = (props) => {
  return (
    <span className={props.className}>
      <div className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </span>
  );
};

Loader.propTypes = {
  className: PropTypes.string,
};

export { Loader };
